import React from "react";
import { Navigate } from "react-router";
import { hasClientAuthSession } from "../../utils/authCookie";

export default function PrivateRoutes({ children }: any) {
  const agree = localStorage.getItem("termsAgree") ?? undefined;
  return hasClientAuthSession() && agree == "false" ? (
    <>{children}</>
  ) : (
    <>
      <Navigate
        to="/"
        state={{ message: "Your Session is expired! Please LogIn" }}
      />
    </>
  );
}
